// extracted by mini-css-extract-plugin
export default {"select":"select--F2UGH","name":"name--pe0t2"};